import './src/scss/theme.scss'
import('../../src/js/app')

require('owl.carousel')

$(document).ready(function () {
  $('.calendar .owl-carousel').owlCarousel({
    loop: true,
    margin: 4,
    nav: true,
    dots: false,
    stagePadding: 30,
    navText: [
      '<i class=\'fa fa-fw fa-chevron-left\'></i>',
      '<i class=\'fa fa-fw fa-chevron-right\'></i>'
    ],
    autoplay: true,
    autoplayHoverPause: true,
    items: 1
  })
  $('.hero-slider.owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: false,
    items: 1
  })
  $('.header-usp.owl-carousel').owlCarousel({
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 2
      },
      600: {
        items: 3
      },
      800: {
        items: 4
      },
      1000: {
        items: 4
      },
      1200: {
        items: 5
      }
    }
  })
})
